import { v4 as uuidv4 } from 'uuid';

// Current app version - update this when releasing new features
export const APP_VERSION = '0.3';

// One hue per class, handed out in turn. The key is the data-hue value in base.css.
export const CLASS_HUES = [
    { key: 'periwinkle', label: 'Blau' },
    { key: 'tangerine', label: 'Orange' },
    { key: 'lime', label: 'Grün' },
    { key: 'lilac', label: 'Flieder' },
];

// Separation groups: 0 is "none", 1 to 3 are shown as A, B and C.
export const GROUP_LETTERS = ['', 'A', 'B', 'C'];

// Partner groups: 0 is "none", 1 to 4 are shown as numbers.
export const PARTNER_GROUPS = 4;

// Where the board (Tafel) is drawn. 'none' hides it.
export const ROOM_FRONTS = [
    { key: 'top', label: 'Tafel oben' },
    { key: 'bottom', label: 'Tafel unten' },
    { key: 'left', label: 'Tafel links' },
    { key: 'right', label: 'Tafel rechts' },
    { key: 'none', label: 'Tafel nicht anzeigen' },
];

export const MIN_ROOM_SIZE = 1;
export const MAX_ROOM_SIZE = 16;

export function nextHue(classes) {
    return CLASS_HUES[classes.length % CLASS_HUES.length].key;
}

export function createRoomFromName(name) {
    let config = {
        name: name,
        tables: [],
        id: uuidv4(),
        rows: 8,
        cols: 10,
        front: 'top',
    }
    for (let i = 0; i < config.rows * config.cols; i++) {
        config.tables.push({ index: i, available: false })
    }
    return config
}

// Resizes in place and keeps every table where it stands. Returns where each
// old table index went, so seating plans can follow.
export function changeRoomSize(room, newRows, newCols) {
    const clamp = n => Math.max(MIN_ROOM_SIZE, Math.min(MAX_ROOM_SIZE, n));
    const rows = clamp(newRows);
    const cols = clamp(newCols);
    const moved = {};
    const tables = [];
    for (let r = 0; r < rows; r++) {
        for (let c = 0; c < cols; c++) {
            const index = r * cols + c;
            const old = r < room.rows && c < room.cols ? room.tables[r * room.cols + c] : null;
            if (old) moved[old.index] = index;
            tables.push({ index, available: !!(old && old.available) });
        }
    }
    room.rows = rows;
    room.cols = cols;
    room.tables = tables;
    return moved
}

export function createClassFromName(name, hue) {
    return {
        students: [],
        name: name,
        id: uuidv4(),
        hue,
    }
}

export function createClassFromNameAndStudents(name, students, hue) {
    return {
        students: students.map(stud => createStudent(stud)),
        name: name,
        id: uuidv4(),
        hue,
    }
}

export function createStudent(name) {
    return {
        name,
        id: uuidv4(),
        blockingGroup: 0,
        partnerGroup: 0,
    }
}

export function plural(count, one, many) {
    return `${count} ${count === 1 ? one : many}`;
}
